import { createSlice } from "@reduxjs/toolkit";
interface IinitialState {
  signupstatus: number;
}

const initialState: IinitialState = {
  signupstatus: 0
};

const userSignUpStatus = createSlice({
  name: "setSignUpdData",
  initialState,
  reducers: {
    setRouteInfoSignupFunc(state, action) {
      state.signupstatus = action.payload;
    },
  },
});

export const {setRouteInfoSignupFunc} = userSignUpStatus.actions;
export default userSignUpStatus;
